import {styled} from "@mui/material/styles";
import {Button, ButtonProps} from "@mui/material";
import {main, shadow} from "../assets/colors";

export const DarkButton = styled(Button)<ButtonProps>(({theme}) => ({
    borderRadius:0,
    color: 'white',
    backgroundColor: main,
    '&:hover': {
        backgroundColor: shadow,
        color:main,
    },
}));

export const LightButton = styled(Button)<ButtonProps>(({theme}) => ({
    borderRadius:0,
    color: main,
    backgroundColor: 'white',
    '&:hover': {
        backgroundColor: main[700],
    },
}));

export const InlineButton = styled(Button)<ButtonProps>(({theme}) => ({
    outline:'none',
    borderRadius:0,
    color: main,
    backgroundColor: 'white',
    '&:hover': {
        backgroundColor: main[700],
    },
    lineHeight:0,
    padding:0,
    minWidth:'0',
    fontSize:'0.875em',
    marginLeft:'20px',
}));